/**
 * Feature flags đọc từ biến môi trường Vite (`import.meta.env`). Mỗi cờ tự khai
 * báo mặc định của nó ngay trong hàm kiểm tra bên dưới.
 */

/**
 * Cho `ProvincesMergedChoropleth` đọc ranh giới từ `GET /api/provinces/boundaries`
 * thay vì file tĩnh `provinces.merged.geojson` (36 MB, tải lại mỗi lần vào trang).
 *
 * Mặc định BẬT: ranh giới theo API dựng từ chuỗi đợt chuyển đổi nên phản ánh
 * đúng lần sáp nhập mới nhất, còn file tĩnh đứng yên cho tới khi có người build
 * lại. Đặt `VITE_PROVINCE_BOUNDARY_API=false` để quay về file tĩnh; component đã
 * có sẵn đường lùi khi API lỗi.
 */
export function isProvinceBoundaryApiEnabled(): boolean {
	return import.meta.env.VITE_PROVINCE_BOUNDARY_API !== 'false';
}
